import React from 'react';
import RecalculateOrdersServiceCostButtonProperties from "./RecalculateOrdersServiceCostButtonProperties";
import RecalculateOrdersServiceCostStore from "./RecalculateOrdersServiceCostStore";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import {Observer} from "mobx-react-lite";
import {useCommonContext} from "../../../contexts/CommonContext";
import useConfirmation from "../../../hooks/ConfirmationDialog";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ButtonType from "../../../ui_components/Button/ButtonType";
import Button from "../../../ui_components/Button/Button";
import {useUserContext} from "../../../contexts/UserContext";
import Access from "../../Access/AllowAccess/Access";
import PriceChangeIcon from '@mui/icons-material/PriceChange';

const RecalculateOrdersServiceCostButton: React.FC<RecalculateOrdersServiceCostButtonProperties> = ({
                                                                        onClick = () => {
                                                                        },
                                                                        showIcon = true,
                                                                        showText = true,
                                                                        disabled,
                                                                        className = '',
                                                                        productOrdersIds,
                                                                        rounded = false,
                                                                        size = ButtonSize.DEFAULT,
                                                                        type = ButtonType.DEFAULT
                                                                    }) => {

    const confirm = useConfirmation();
    const userStore = useUserContext();
    const commonContext = useCommonContext();

    const store = new RecalculateOrdersServiceCostStore(commonContext, productOrdersIds);

    const handleOnclick = async () => {
        onClick();
        const ok = await confirm("Confirmación", `¿Está seguro que desea recalcular el valor de costo ${productOrdersIds.length > 1 ? 'de los envíos' : 'del envío'}?`);
        if (ok) {
            await store.recalculate();
        }
    }

    const text = `Recalcular valor de costo`;
    if (!userStore.hasAccess(Access.RECALCULATE_PRODUCT_ORDERS_SERVICE_COST.valueOf())) {
        return <></>;
    }

    const Btn = () => {
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                size={size}
                type={type}
                icon={showIcon ? <PriceChangeIcon/> : <></>}
            />
        }
        return <Button
            onClick={handleOnclick}
            className={className}
            disabled={disabled}
            tooltip={!showText ? text : ""}
            text={showText ? text : ""}
            size={size}
            type={type}
            startIcon={showIcon ? <PriceChangeIcon/> : <></>}
        />
    }

    return <Observer>
        {() => (
            <Btn/>
        )}
    </Observer>
}

export default RecalculateOrdersServiceCostButton;
